import { ICarrierLocationBranchStatus } from '../interfaces';

export const CARRIER_LOCATION_BRANCH_STATUS_MAP: Record<ICarrierLocationBranchStatus, { label: string; color: string }> = {
  active: { label: 'Mövcuddur', color: 'green' },
  soft_deleted: { label: 'Silinib', color: 'red' },
  not_exist: { label: 'Yaradılmayıb', color: 'default' },
};

/** Declarations in this state sit in the local warehouse and need a container in the target branch when transferred. */
export const BRANCH_TRANSFER_LOCAL_WAREHOUSE_STATE_ID = 9;
